import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import Loading from "./loading.js";
import AddLead from "./addLead.js";
import ImportLead from "./importLead";
import MultiSelect from "./multiSelect.js";
import { secretKey } from "./data";
import LeadDetail from "./leadDetail";
import { faEdit, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { downloadExcel } from "react-export-table-to-excel";
import AddCon from "./addCon";

const MySwal = withReactContent(Swal2);

const Recommendations = (props) => {
  const [loading, setLoading] = useState(true);
  const [leads, setLeads] = useState([]);
  const [leadsOri, setLeadsOri] = useState([]);
  const [users, setUsers] = useState([]);
  const [showLeadDetail, setShowLeadDetail] = useState(false);
  const [filterUser, setFilterUser] = useState("");
  const [selectedOptionsUser, setSelectedOptionsUser] = useState([]);
  const [isHoveringUser, setIsHoveringUser] = useState(false);
  const [filterDateFrom, setFilterDateFrom] = useState("");
  const [filterDateTo, setFilterDateTo] = useState("");
  const [filterDate, setFilterDate] = useState(false);
  const [con, setCon] = useState("");
  const [sort, setSort] = useState("dateDesc");
  const [checkLead, setCheckLead] = useState([]);
  const [showCheckCon, setShowCheckCon] = useState(false);

  const closeLeadDetail = () => {
    setShowLeadDetail(false);
    getData();
  };

  const closeCheckCon = () => {
    setShowCheckCon(false);
    setCon("");
    setCheckLead([]);
    getData();
  };

  const fetchLeadsAss = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getLeadsAssData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLeads(data.filter((el) => el.recommender));
        setLeadsOri(data.filter((el) => el.recommender));
        handleFilterChange(
          "",
          "",
          data.filter((el) => el.recommender)
        );
        fetchUsersList();
      })
      .catch((error) => {});
  };

  const fetchLeadsAssUser = async () => {
    var body = { user: props.user.id };

    await fetch("https://apisplit.ftpeople.pl/getLeadsAssUserData", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setLeads(data.filter((el) => el.recommender));
        setLeadsOri(data.filter((el) => el.recommender));
        handleFilterChange(
          "",
          "",
          data.filter((el) => el.recommender)
        );
        fetchUsersList();
      })
      .catch((error) => {});
  };

  const fetchUsersList = async () => {
    var body = {};

    await fetch("https://apisplit.ftpeople.pl/getUsersList", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setUsers(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    props.user.role === "admin" ? fetchLeadsAss() : fetchLeadsAssUser();
  };

  useEffect(() => {
    getData();
  }, []);

  const leadsData = (
    <>
      <div>
        <p style={{ textAlign: "left", margin: "0", fontSize: ".8vw" }}>
          Liczba kontaktów: {leads.length}
        </p>
        <div>
          <table
            style={{
              marginTop: "0vh",
              overflowX: "auto",
            }}
            className="clients_table"
          >
            <tr key={0}>
              <th style={{ width: "15vw" }}>kto polecał</th>
              <th style={{ width: "10vw" }}>polecony</th>
              <th style={{ width: "10vw" }}>data polecenia</th>
            </tr>
            {leads.map((el, index) => (
              <>
                <tr>
                  <td>{el.recommender}</td>
                  <td>{el.name}</td>
                  <td>{el.recommendationDate}</td>
                </tr>
              </>
            ))}
          </table>
        </div>
      </div>
    </>
  );

  const createExcelDS = () => {
    var tab = [];
    leads.map((el) => {
      tab.push([el.recommender, el.name, el.recommendationDate]);
    });
    return tab;
  };

  const exportToExcel = (e) => {
    var header = ["Kto polecał", "Polecony", "Data polecenia"];
    downloadExcel({
      fileName: "leads_recommendations_report_" + new Date(),
      sheet: "data",
      tablePayload: {
        header,
        body: createExcelDS(),
      },
    });
  };

  const clearFilters = (e) => {
    setFilterUser([]);
    setSelectedOptionsUser([]);
    setFilterDateFrom("");
    setFilterDateTo("");
    setFilterDate(false);
    setSort("dateDesc");
    setLeads(leadsOri);
  };

  const getUserOptions = (e) => {
    var arr = [];
    arr.push({ label: "Wszystkie", value: "all" });

    users.map((el) => {
      var opt = { label: el.name, value: el.id };
      arr.push(opt);
    });

    return arr;
  };

  const checkOptionNum = (arr, value) => {
    if (arr.filter((el) => +el === +value).length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const handleFilterChange = (value, mode, data) => {
    var arr = data;

    var fUser = mode === "filterUser" ? value : filterUser;
    if (filterUser.length > 0 || mode === "filterUser") {
      arr = arr.filter((el) => checkOptionNum(fUser, el.seller));
    }

    var fDate = mode === "filterDate" ? value : filterDate;
    if (fDate) {
      arr = arr.filter(
        (el) =>
          new Date(el.recommendationDate) >= new Date(filterDateFrom) &&
          new Date(el.recommendationDate) <= new Date(filterDateTo)
      );
    }

    setLeads(arr);
    handleSortChange(sort, arr);
  };

  const handleChangeFilterUser = (e) => {
    setFilterUser(e);
    handleFilterChange(e, "filterUser", leadsOri);
  };

  const closeAllHovering = (e) => {
    if (e.target.id !== "user") {
      setIsHoveringUser(false);
    }
  };

  const handleChangeFilterDateFrom = (e) => {
    if (new Date(e.target.value) > new Date(filterDateTo)) {
      MySwal.fire({
        icon: "error",
        title: "Data od",
        text: 'nie może być większa niż "Data do"',
      });
      return;
    }
    setFilterDateFrom(e.target.value);
  };

  const handleChangeFilterDateTo = (e) => {
    if (new Date(e.target.value) < new Date(filterDateFrom)) {
      MySwal.fire({
        icon: "error",
        title: "Data do",
        text: 'nie może być mniejsza niż "Data od"',
      });
      return;
    }
    setFilterDateTo(e.target.value);
  };

  const handleChangeFilterDate = (e) => {
    if (filterDateFrom && filterDateTo) {
      setFilterDate(true);
      handleFilterChange(true, "filterDate", leadsOri);
    }
  };

  const handleSortChange = (mode, data) => {
    if (mode === "") {
      return;
    }

    if (mode === "dateAsc") {
      setLeads(
        data.sort(function (a, b) {
          return (
            new Date(a.recommendationDate) - new Date(b.recommendationDate)
          );
        })
      );
    } else if (mode === "dateDesc") {
      setLeads(
        data.sort(function (a, b) {
          return (
            new Date(b.recommendationDate) - new Date(a.recommendationDate)
          );
        })
      );
    }
  };

  const handleSortDataChange = (e) => {
    setSort(e.target.value);
    handleSortChange(e.target.value, leads);
  };

  return (
    <>
      <div onClick={closeAllHovering}>
        {loading ? (
          <Loading />
        ) : (
          <>
            {showCheckCon ? (
              <>
                <AddCon
                  con={con}
                  close={closeCheckCon}
                  lead={checkLead}
                  user={props.user}
                />
              </>
            ) : (
              ""
            )}

            <>
              <div
                style={{
                  position: "fixed",
                  backgroundColor: "white",
                  width: "75vw",
                  top: "0",
                  paddingTop: "5vh",
                  paddingBottom: "3vh",
                  paddingLeft: "2vw",
                  paddingRight: "2vw",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "left",
                    gap: "1vw",
                  }}
                >
                  <button
                    className="loginButtonLogin"
                    value="yes"
                    style={{
                      margin: "0",
                      backgroundColor: "green",
                      borderColor: "green",
                      width: "180px",
                    }}
                    onClick={getData}
                  >
                    ODŚWIEŻ
                  </button>

                  {props.user.role === "admin" ? (
                    <button
                      className="loginButtonLogin"
                      value="yes"
                      style={{
                        margin: "0",
                        backgroundColor: "blue",
                        borderColor: "blue",
                        width: "180px",
                      }}
                      onClick={exportToExcel}
                    >
                      EKSPORT DO EXCEL
                    </button>
                  ) : (
                    ""
                  )}
                </div>
                <div style={{ marginTop: "2vh" }}>
                  <p style={{ textAlign: "left", fontWeight: "600" }}>FILTRY</p>

                  <div
                    style={{
                      display: "flex",
                      gap: "5px 20px",
                      flexWrap: "wrap",
                      alignItems: "center",
                    }}
                  >
                    {props.user.role === "admin" ? (
                      <>
                        <div style={{ width: "15%", textAlign: "left" }}>
                          <p
                            style={{
                              margin: "0",
                              marginBottom: "10px",
                              fontWeight: "600",
                              fontSize: ".6vw",
                              paddingLeft: "2px",
                            }}
                          >
                            handlowiec
                          </p>
                          <MultiSelect
                            options={getUserOptions()}
                            value={filterUser}
                            onChange={handleChangeFilterUser}
                            selectedOptions={selectedOptionsUser}
                            setSelectedOptions={setSelectedOptionsUser}
                            isHovering={isHoveringUser}
                            setIsHovering={setIsHoveringUser}
                            id={"user"}
                            closeAllHovering={closeAllHovering}
                          />
                        </div>
                      </>
                    ) : (
                      ""
                    )}

                    <>
                      <div style={{ width: "100%" }}></div>
                    </>

                    <div style={{ display: "block" }}>
                      <div
                        style={{
                          marginBottom: "1vh",
                          width: "100%",
                          textAlign: "left",
                        }}
                      >
                        <label
                          style={{
                            fontSize: ".6vw",
                            fontWeight: "600",
                            paddingLeft: "5px",
                          }}
                        >
                          data polecenia
                        </label>
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            width: "100%",
                          }}
                          className="inputBox"
                        >
                          <div style={{ width: "45%" }}>
                            <label
                              style={{ fontSize: ".6vw", paddingLeft: "5px" }}
                            >
                              od
                            </label>
                            <input
                              style={{ height: "3vh", width: "100%" }}
                              type="date"
                              id="name"
                              name="name"
                              value={filterDateFrom}
                              onChange={handleChangeFilterDateFrom}
                            />
                          </div>
                          <div style={{ width: "45%" }}>
                            <label
                              style={{ fontSize: ".6vw", paddingLeft: "5px" }}
                            >
                              do
                            </label>
                            <input
                              style={{ height: "3vh", width: "100%" }}
                              type="date"
                              id="name"
                              name="name"
                              value={filterDateTo}
                              onChange={handleChangeFilterDateTo}
                            />
                          </div>
                        </div>
                        <div style={{ marginTop: "10px", textAlign: "left" }}>
                          <button
                            style={{
                              backgroundColor: "navy",
                              border: "none",
                              color: "white",
                              textTransform: "uppercase",
                              fontWeight: "600",
                              borderRadius: "5px",
                            }}
                            id="clientsFilterButton"
                            className="paymentMenuButton"
                            onClick={handleChangeFilterDate}
                          >
                            Zastosuj filtr daty
                          </button>
                        </div>
                      </div>
                    </div>
                    <button
                      className="loginButtonLogin"
                      value="yes"
                      style={{
                        margin: "0",
                        backgroundColor: "green",
                        borderColor: "green",
                        width: "140px",
                        fontSize: ".6vw",
                        height: "3vh",
                      }}
                      onClick={clearFilters}
                    >
                      WYCZYŚĆ FILTRY
                    </button>
                  </div>
                </div>
                <div style={{ textAlign: "right", width: "100%" }}>
                  <select
                    style={{ height: "3vh", width: "25%" }}
                    type="date"
                    id="name"
                    name="name"
                    value={sort}
                    onChange={handleSortDataChange}
                  >
                    {sort === "" ? (
                      <option key={2}>Wybierz sortowanie...</option>
                    ) : (
                      ""
                    )}
                    <option key={0} value="dateAsc">
                      Data pozyskania - od najstarszej
                    </option>
                    <option key={1} value="dateDesc">
                      Data pozyskania - od najmłodszej
                    </option>
                  </select>
                </div>
              </div>
              <div
                style={{
                  paddingTop: "38vh",
                  paddingLeft: "2vw",
                  paddingRight: "2vw",
                }}
              >
                {leadsData}
              </div>
            </>
          </>
        )}
      </div>
    </>
  );
};

export default Recommendations;
